import React from 'react';
const items = [{
  name: '12 digitale Bände',
  value: '97€'
}, {
  name: '5 Bonus-PDFs',
  value: '150€'
}];
export function PricingSection() {
  return <section id="pricing" className="w-full bg-bg-alt py-16 sm:py-24 px-4" data-id="element-167">
      <div className="max-w-3xl mx-auto" data-id="element-168">
        <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main text-center mb-10 sm:mb-16" data-id="element-169">
          🏆 Spezielles Einführungsangebot
        </h2>

        <div className="bg-bg-alt rounded-3xl border-2 border-primary p-6 sm:p-10 shadow-lg relative max-w-xl mx-auto" data-id="element-170">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-white font-bold text-xs sm:text-sm px-6 py-2 rounded-full uppercase tracking-wider whitespace-nowrap" data-id="element-171">
            INHALT DES PAKETS:
          </div>

          <div className="mt-6 space-y-4 mb-8" data-id="element-172">
            {items.map((item, i) => <div key={i} className="flex justify-between items-center text-text-main font-medium text-base sm:text-lg border-b border-border-light pb-3" data-id="element-173">
                <span data-id="element-174">{item.name}</span>
                <span className="text-secondary line-through" data-id="element-175">
                  {item.value}
                </span>
              </div>)}
            <div className="flex justify-between items-center font-black text-lg sm:text-xl pt-2" data-id="element-176">
              <span data-id="element-177">GESAMTWERT:</span>
              <span className="text-secondary line-through" data-id="element-178">247€</span>
            </div>
          </div>

          <div className="text-center mb-8" data-id="element-179">
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-180">
              <span className="text-5xl sm:text-6xl" data-id="element-181">🏆</span>
              <span className="font-serif font-black text-6xl sm:text-8xl text-primary leading-none" data-id="element-182">
                19€
              </span>
            </div>
            <p className="text-secondary line-through font-bold text-lg sm:text-xl mb-3" data-id="element-183">
              247€
            </p>
            <p className="text-text-sec text-sm sm:text-base font-medium max-w-sm mx-auto" data-id="element-184">
              ⏳ Einführungspreis — der Preis kann nach der Einführungsphase
              steigen.
            </p>
          </div>

          <a href="https://sportunterricht-fertig.impultienda.ar/checkout" className="btn-primary-pulse w-full flex items-center justify-center gap-2 text-center bg-primary text-white font-bold text-lg sm:text-xl py-4 sm:py-5 rounded-2xl hover:bg-primary-hover transition-colors mb-6" data-id="element-185">
            <span aria-hidden="true" data-id="element-186">🚀</span>
            ICH WILL DAS KOMPLETTE PAKET FÜR 19€
          </a>

          <p className="text-center text-text-sec text-xs sm:text-sm font-medium flex flex-wrap items-center justify-center gap-x-4 gap-y-2" data-id="element-187">
            <span className="flex items-center gap-1" data-id="element-188">
              <span aria-hidden="true" data-id="element-189">🔒</span> Sicherer Kauf
            </span>
            <span className="flex items-center gap-1" data-id="element-190">
              <span aria-hidden="true" data-id="element-191">⚡</span> Sofortiger Zugang
            </span>
            <span className="flex items-center gap-1" data-id="element-192">
              <span aria-hidden="true" data-id="element-193">🛡️</span> 7 Tage Geld-zurück-Garantie
            </span>
            <span className="flex items-center gap-1" data-id="element-194">
              <span aria-hidden="true" data-id="element-195">📘</span> 100% PDF
            </span>
          </p>
        </div>
      </div>
    </section>;
}